import { type SimpleOption } from 'legacy/dash-blocks/dash-select/utils/select.types'
import { type DashTablePageSize } from 'legacy/dash-blocks/dash-table/utils/dashTable.types'

export const DASH_TABLE_PAGE_SIZE_OPTIONS: SimpleOption<DashTablePageSize>[] = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
]
